/**
 * Utility functions for web-shield
 */

/**
 * Safe version of querySelectorAll that handles errors
 */
export function safeQuerySelectorAll(selector: string, parent: Document | Element = document): Element[] {
  try {
    return Array.from(parent.querySelectorAll(selector));
  } catch (error) {
    console.warn(`web-shield: Error with selector "${selector}"`, error);
    return [];
  }
}

/**
 * Safely adds event listener with error handling
 */
export function safeAddEventListener(
  element: EventTarget,
  type: string, 
  handler: EventListener
): boolean {
  try {
    element.addEventListener(type, handler);
    return true;
  } catch (error) {
    console.warn(`web-shield: Error adding ${type} event listener`, error);
    return false;
  }
}

/**
 * Creates a robust MutationObserver with comprehensive observation options
 */
export function createRobustMutationObserver(
  callback: (mutations: MutationRecord[]) => void
): MutationObserver {
  const observer = new MutationObserver(callback);
  
  // More comprehensive observation options
  observer.observe(document.body, { 
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'class', 'id']
  });
  
  return observer;
}